// Reads the optional dev-routing env vars used by config-fetch to inject
// development-only request headers (mirrord and Kong preview-route).
//
// Extracted into its own module so tests can vi.mock it cleanly. Vitest gives
// each module its own `import.meta`, so stubbing the env vars from a test file
// doesn't reach the source module; mocking this helper does.

export interface DevRoutingEnv {
  mirrordRoute?: string;
  previewRoute?: string;
}

// Shape of `import.meta` as Vite makes it available at runtime. We type it
// inline (rather than via a `vite-env.d.ts` triple-slash reference) because
// the type assertion needs to be visible to every consumer that compiles
// this file — `.d.ts` files only apply to their owning package's tsconfig.
type ImportMetaWithViteEnv = {
  env: {
    VITE_MIRRORD_ROUTE?: string;
    VITE_PREVIEW_ROUTE?: string;
  };
};

// Vite replaces `import.meta.env.VITE_*` as a *static* path substitution at
// build time — destructuring or aliasing the env object breaks the
// replacement and the values end up undefined at runtime. The inline casts
// erase at compile time (the runtime AST is still `import.meta.env.VITE_X`),
// so Vite's substitution still applies.
// https://vite.dev/guide/env-and-mode.html
export const getDevRoutingEnv = (): DevRoutingEnv => ({
  mirrordRoute: (import.meta as unknown as ImportMetaWithViteEnv).env
    .VITE_MIRRORD_ROUTE,
  previewRoute: (import.meta as unknown as ImportMetaWithViteEnv).env
    .VITE_PREVIEW_ROUTE,
});
